import {
  EntityIcon,
  getTruncateMaxLinesStyle,
  WbBreadcrumb,
  WbBreadcrumbs,
} from '@agilelab/plugin-wb-platform';
import {
  Box,
  makeStyles,
  Typography,
  TypographyProps,
} from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import { ResultTitle } from '../../../Entity';
import { Row } from './utils';

const useStyles = makeStyles(
  () => ({
    nameRoot: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
      whiteSpace: 'normal',
    },
    nameContainer: {
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },

    descriptionText: getTruncateMaxLinesStyle(2),
    date: getTruncateMaxLinesStyle(1, false),
  }),
  { name: 'SearchResultsTableCells' },
);

type NameCellProps = {
  searchResult: Row;
};

export const NameCell = ({ searchResult }: NameCellProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.nameRoot}>
      <EntityIcon
        useCaseTemplateId={searchResult.useCaseTemplateId}
        kind={searchResult._computedInfo.kind}
        title={searchResult.title}
        style={{ flexShrink: 0 }}
        taxonomyUrn={searchResult._computedInfo.taxonomy.external_id}
      />
      <Box className={classes.nameContainer}>
        <ResultTitle
          concise
          title={searchResult._nameWithVersion}
          location={searchResult.location}
        />
        <WbBreadcrumbs variant="secondary" disableLastItemHighlight>
          {searchResult._resolvedDomains.map(d => (
            <WbBreadcrumb key={d}>{d}</WbBreadcrumb>
          ))}
          {searchResult._systemParentDisplayName && (
            <WbBreadcrumb>{searchResult._systemParentDisplayName}</WbBreadcrumb>
          )}
          {searchResult._componentParentDisplayName && (
            <WbBreadcrumb>
              {searchResult._componentParentDisplayName}
            </WbBreadcrumb>
          )}
        </WbBreadcrumbs>
      </Box>
    </Box>
  );
};

export const DescriptionCell = ({
  children,
  title,
  ...props
}: TypographyProps & { title: string }) => {
  const classes = useStyles();

  return (
    <WbTooltip title={title}>
      <Typography className={classes.descriptionText} {...props}>
        {children}
      </Typography>
    </WbTooltip>
  );
};

export const DateCell = ({
  date,
  ...props
}: TypographyProps & { date?: string }) => {
  const classes = useStyles();

  if (!date) return <></>;

  const parsedDate = new Date(date).toLocaleString();

  return (
    <WbTooltip title={parsedDate}>
      <Typography className={classes.date} {...props}>
        {parsedDate}
      </Typography>
    </WbTooltip>
  );
};
